import { render, staticRenderFns } from "./EditPageSection.vue?vue&type=template&id=1bd5ba87&scoped=true&"
import script from "./EditPageSection.vue?vue&type=script&lang=js&"
export * from "./EditPageSection.vue?vue&type=script&lang=js&"
import style0 from "./EditPageSection.vue?vue&type=style&index=0&id=1bd5ba87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5ba87",
  null
  
)

export default component.exports